import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Container, Row } from "react-bootstrap";

import Tile from "../../../Tile";
import "./styles.scss";
import { NO_DATE_SELECTED } from "../../../../constants/messages";

const DateRange = ({
  dates = [],
  selected,
  onSelect,
  defaultHeaderDate,
  meta,
  getDay,
  getDayMonth,
  getDayOfWeek,
  ...rest
}) => (
  <Container className={"mydpd-day-picker p-0"}>
    <Container className={"title"}>
      <Row className={"selected"}>
        {selected || defaultHeaderDate
          ? getDayMonth(selected || defaultHeaderDate)
          : NO_DATE_SELECTED}
      </Row>
    </Container>
    <Container className="p-0">
      <Tile.Stack className={classNames("days-container", "m-0")}>
        {dates.map((date, i) => {
          const classes = {
            container: classNames(
              "days-card",
              date === selected && "days-card-active",
              meta.error && meta.touched && "days-card-error"
            ),
            body: "days-body",
            footer: classNames(
              "days-footer",
              date === selected && "days-footer-active"
            ),
            footerText: "days-footer-text",
          };
          return (
            <Tile
              classes={classes}
              key={i}
              title={getDay(date)}
              onClick={() => {
                onSelect(date);
              }}
              {...rest}
            >
              {getDayOfWeek(date)}
            </Tile>
          );
        })}
      </Tile.Stack>
      {meta.error && meta.touched && (
        <div className="error-message">{meta.error}</div>
      )}
    </Container>
  </Container>
);

DateRange.propTypes = {
  selected: PropTypes.string,
  defaultHeaderDate: PropTypes.string,
  dates: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelect: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  meta: PropTypes.object,
  getDay: PropTypes.func,
  getDayMonth: PropTypes.func,
  getDayOfWeek: PropTypes.func,
};

export default DateRange;
